export const formatSourceLabel = (sourceUrl: string): string => {
	try {
		const url = new URL(sourceUrl);
		const path = url.pathname.replace(/\/$/, '');
		return path ? `${url.hostname}${path}` : url.hostname;
	} catch {
		return sourceUrl;
	}
};
